import React from 'react'
import { Navigate, Outlet } from 'react-router'

import { ROUTES } from '../../constants/routes'
import { useSession } from '../../hooks/useSession'
import AppHeader from '../AppHeader'
import Footer from '../Footer'
import { MainContent } from '../misc/MainContent'
import { SentryErrorBoundary } from '../misc/SentryErrorBoundary'

export default function AppLayout() {
  const { isGuest } = useSession()

  if (isGuest) {
    return <Navigate to={ROUTES.login} />
  }

  return (
    <>
      <AppHeader />
      <MainContent>
        <SentryErrorBoundary>
          <Outlet />
        </SentryErrorBoundary>
      </MainContent>
      <Footer />
    </>
  )
}
